/**
 * Configuración en **runtime**, no en build.
 *
 * Vite incrusta `import.meta.env` al compilar. Si horneáramos ahí la URL del
 * gateway necesitaríamos una imagen por entorno. En su lugar, el contenedor genera
 * `/config.js` al arrancar desde variables de entorno y la app lo lee de
 * `window.__ALPACA_CONFIG__`: **la misma imagen sirve para local, staging y
 * producción**, que es lo que espera Dokploy.
 *
 * En `npm run dev` no hay contenedor, así que se cae a `VITE_GATEWAY_URL`.
 */

declare global {
  interface Window {
    __ALPACA_CONFIG__?: { gatewayUrl?: string }
  }
}

const POR_DEFECTO = "http://localhost:8000"

export function gatewayUrl(): string {
  const runtime = window.__ALPACA_CONFIG__?.gatewayUrl
  if (runtime && !runtime.startsWith("__")) return runtime.replace(/\/$/, "")

  const dev = import.meta.env["VITE_GATEWAY_URL"] as string | undefined
  return (dev ?? POR_DEFECTO).replace(/\/$/, "")
}
